export default "__VITE_ASSET__555d2d63__"